import React, { useState } from "react";
import { FaChevronCircleLeft } from "react-icons/fa";
import { useNavigate } from "react-router";
import { FormCabinetContext } from "./types";
import { Timeout, formattedDate } from "../../functions/functions";
import ButtonElement from "../../HtmlComponents/ButtonElement";
import InputsCabinet from "./forms/InputsCabinet";
import { useDispatch } from "react-redux";
import { AddCabinetApi } from "../../redux/cabinets/cabinetApiCalls";
import ShowErrorMsg from "../../HtmlComponents/ShowErrorMsg";
import SuccessMsg from "../../Messages/SuccessMsg";

const CreateCabinet = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [logo, setLogo] = useState<File | any>(null);
  const [authorization, setAuthorization] = useState("");
  const [type, setType] = useState("");
  const [moughataa, setMoughataa] = useState<any>({});
  const [chooseDoctor, setChooseDoctor] = useState<any>(null);
  const [existedDoctor, setExistedDoctor] = useState<boolean>(true);

  const [fullName, setFullName] = useState("");
  const [yearOfBirth, setYearOfBirth] = useState("");
  const [placeOfBirth, setPlaceOfBirth] = useState("");
  const [sex, setSex] = useState("");
  const [telephone, setTelephone] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [email, setEmail] = useState("");
  const [current, setCurrent] = useState<string>("");
  const [medecinType, setMedecinType] = useState<any>(null);
  const [origin, setOrigin] = useState("");
  const [inscriptionDate, setInscriptionDate] = useState(
    formattedDate(new Date().toString())
  );
  const [avatar, setAvatar] = useState<File | any>(null);
  const [password, setPassword] = useState("");
  const [speciality, setSpeciality] = useState("");

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);

  const dispatch: any = useDispatch();

  const [showSuccessMsg, setShowSuccessMsg] = useState(false);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const formData: any = new FormData();

      formData.append("name", name);
      formData.append("phone", phone);
      formData.append("address", address);
      formData.append("logo", logo);
      formData.append("authorization", authorization);
      formData.append("type", type);
      formData.append("moughataa", moughataa?.value);
      formData.append("chooseDoctor", chooseDoctor);
      formData.append("existedDoctor", JSON.stringify(existedDoctor));

      formData.append("fullName", fullName);
      formData.append("yearOfBirth", yearOfBirth);
      formData.append("placeOfBirth", placeOfBirth);
      formData.append("sex", sex);
      formData.append(
        "contact",
        JSON.stringify({
          phone: telephone,
          whatsapp,
          email,
        })
      );
      formData.append(
        "nationality",
        JSON.stringify({
          current,
          origin,
        })
      );
      formData.append("medecinType", medecinType);
      formData.append("inscriptionDate", inscriptionDate);
      formData.append("avatar", avatar);
      formData.append("password", password);
      formData.append("speciality", speciality);

      const response: any = await dispatch(AddCabinetApi(formData));
      if (response === true) {
        // show success Msg
        setShowSuccessMsg(true);
        setTimeout(() => navigate("/cabinet"), Timeout);
      } else {
        setErrors(response);
      }

      setLoading(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <FormCabinetContext.Provider
      value={{
        name,
        setName,
        phone,
        setPhone,
        address,
        setAddress,
        logo,
        setLogo,
        authorization,
        setAuthorization,
        type,
        setType,
        moughataa,
        setMoughataa,
        chooseDoctor,
        setChooseDoctor,
        existedDoctor,
        setExistedDoctor,

        fullName,
        setFullName,
        yearOfBirth,
        setYearOfBirth,
        placeOfBirth,
        setPlaceOfBirth,
        sex,
        setSex,
        telephone,
        setTelephone,
        whatsapp,
        setWhatsapp,
        email,
        setEmail,
        current,
        setCurrent,
        medecinType,
        setMedecinType,
        origin,
        setOrigin,
        inscriptionDate,
        setInscriptionDate,
        avatar,
        setAvatar,
        password,
        setPassword,
        speciality,
        setSpeciality,
      }}
    >
      <div className="mt-20 px-4">
        <div className="bg-white p-6 rounded-xl shadow-lg max-w-screen-lg mx-auto">
          {/* Success Message */}
          <SuccessMsg
            modal={showSuccessMsg}
            toggle={() => setShowSuccessMsg(!showSuccessMsg)}
          />

          {/* Title & Back Button */}
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-xl font-bold text-gray-800">
              Ajouter un nouveau clinique
            </h1>
            <button
              onClick={() => navigate(-1)}
              title="Retour"
              className="p-2 rounded-full btn-main hover:bg-mainColor-hover transition"
            >
              <FaChevronCircleLeft className="text-xl" />
            </button>
          </div>

          {/* Error Messages */}
          <ShowErrorMsg errors={errors} setErrors={setErrors} />

          {/* Form */}
          <form
            className="grid md:grid-cols-2 gap-4 mt-4"
            encType="multipart/form-data"
            onSubmit={handleSubmit}
          >
            <InputsCabinet />

            {/* Submit Button */}
            <div className="md:col-span-2 flex justify-end">
              <ButtonElement
                type="submit"
                loading={loading}
                typeBtn="Ajouter"
              />
            </div>
          </form>
        </div>
      </div>
    </FormCabinetContext.Provider>
  );
};

export default CreateCabinet;
